import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../state/ff-page/actions';
import FollowingFollowers from '../../components/ff';
import { isOwnProfile } from '../../state/members/selectors';
import { isAllMembersInstalled, getViewMode, getIsMobile, isExperimentEnabled } from '../../state/site/selectors';
import { isLoading, getMemberIds, getTotalMembersCount, getPageType, getHasNext } from '../../state/ff-page/selectors';
import { Experiments } from '../../constants/experiments';

const FIRST_PAGE_ID = 1;

export class FFPage extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { fetchMembers, viewMode } = this.props;

    if (nextProps.viewMode !== viewMode) {
      fetchMembers(FIRST_PAGE_ID);
    }
  }

  render() {
    const { fetchMembers, hasNext, isFollowersV3Enabled, membersIds, totalMembersCount } = this.props;

    const hasMoreMembers = isFollowersV3Enabled ? hasNext : membersIds.length < totalMembersCount;

    const otherProps = _.pick(this.props, [
      'isLoading',
      'membersIds',
      'pageType',
      'goToFFPage',
      'goToMemberPage',
      'exitModal',
      'goToMembersPage',
      'isAllMembersInstalled',
      'isOwnProfile',
      'onRoleAction',
    ]);

    return (
      <FollowingFollowers hasMoreMembers={hasMoreMembers} fetchMembers={(page) => fetchMembers(page)} {...otherProps} />
    );
  }
}

FFPage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  membersIds: PropTypes.array.isRequired,
  totalMembersCount: PropTypes.number.isRequired,
  fetchMembers: PropTypes.func.isRequired,
  pageType: PropTypes.string.isRequired,
  goToFFPage: PropTypes.func,
  goToMemberPage: PropTypes.func,
  exitModal: PropTypes.func,
  goToMembersPage: PropTypes.func.isRequired,
  isAllMembersInstalled: PropTypes.bool.isRequired,
  isOwnProfile: PropTypes.bool,
  viewMode: PropTypes.string.isRequired,
  onRoleAction: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  hasNext: PropTypes.bool.isRequired,
  isFollowersV3Enabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: isLoading(state),
  membersIds: getMemberIds(state),
  totalMembersCount: getTotalMembersCount(state),
  pageType: getPageType(state),
  isAllMembersInstalled: isAllMembersInstalled(state),
  isOwnProfile: isOwnProfile(state),
  viewMode: getViewMode(state),
  isMobile: getIsMobile(state),
  hasNext: getHasNext(state),
  isFollowersV3Enabled: isExperimentEnabled(state, Experiments.USE_FOLLOWERS_V3),
});

const mapDispatchToProps = {
  fetchMembers: actions.fetchMembers,
  goToFFPage: actions.goToFFPage,
  goToMemberPage: actions.goToMemberPage,
  exitModal: actions.exitModal,
  goToMembersPage: actions.goToMembersPage,
  onRoleAction: actions.onRoleAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FFPage);
